module.exports = __webpack_public_path__ + "img/fotos_6.00632150.jpg";